module.exports = __webpack_public_path__ + "img/solution5.021781e0.png";